import { type PaymentMethodsResponse } from '@adyen/adyen-web';

import type {
    AdyenProviderInitData,
    ProviderInitData,
    WorldpayProviderInitData
} from '../core/provider-types';
import { AvailablePaymentMethodsV1Dto } from '../types';

export const parseProviderInitData = (
    provider: AvailablePaymentMethodsV1Dto
): ProviderInitData | undefined => {
    if (provider.paymentProvider === 'ADYEN') {
        if (!provider.paymentProviderData?.adyen?.paymentMethodsJson) {
            return undefined;
        }

        const paymentMethodsResponse = JSON.parse(
            provider.paymentProviderData.adyen.paymentMethodsJson
        ) as PaymentMethodsResponse;

        const adyenData: AdyenProviderInitData = {
            provider: 'ADYEN',
            paymentMethodsResponse
        };

        return adyenData;
    }

    if (provider.paymentProvider === 'WORLDPAY') {
        const worldpayData: WorldpayProviderInitData = {
            provider: 'WORLDPAY'
        };

        return worldpayData;
    }

    return undefined;
};
